import { Link } from "react-router-dom";
import DocNavigation from "../../components/DocNavigation";

export default function WhoIsThisFor() {
    return (
        <div className="space-y-20">

            {/* TITLE */}
            <section className="bg-white rounded-xl border border-slate-200 p-10">
                <h1 className="text-2xl font-bold text-slate-900 mb-4">
                    Who Is EventFlow For?
                </h1>

                <p className="text-md text-slate-600 max-w-3xl">
                    EventFlow is designed for the people who run events behind the scenes.
                    Each role gets exactly what they need — nothing more, nothing less.
                </p>
            </section>

            {/* PERSONAS */}
            <section className="space-y-16">

                {/* OWNER */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                    <div className="lg:col-span-1">
                        <div className="bg-[#C9A24E]/10 rounded-xl p-6">
                            <h2 className="text-xl font-semibold mb-2">
                                Banquet Owner
                            </h2>
                            <p className="text-slate-700">
                                Focused on revenue, growth, and operational visibility.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-8">
                        <h3 className="font-semibold mb-4">How EventFlow Helps</h3>
                        <ul className="space-y-3 text-slate-600">
                            <li>• Complete visibility of bookings and revenue</li>
                            <li>• Elimination of manual registers and guesswork</li>
                            <li>• Accurate financial reports at any time</li>
                            <li>• Better control over staff operations</li>
                        </ul>
                    </div>
                </div>

                {/* MANAGER */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                    <div className="lg:col-span-1">
                        <div className="bg-slate-100 rounded-xl p-6">
                            <h2 className="text-xl font-semibold mb-2">
                                Operations Manager
                            </h2>
                            <p className="text-slate-700">
                                Responsible for smooth day-to-day event execution.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-8">
                        <h3 className="font-semibold mb-4">How EventFlow Helps</h3>
                        <ul className="space-y-3 text-slate-600">
                            <li>• Clear event schedules with no conflicts</li>
                            <li>• Live availability calendar</li>
                            <li>• Quick access to event details and services</li>
                            <li>• Reduced coordination errors</li>
                        </ul>
                    </div>
                </div>

                {/* FRONT DESK */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                    <div className="lg:col-span-1">
                        <div className="bg-[#C9A24E]/10 rounded-xl p-6">
                            <h2 className="text-xl font-semibold mb-2">
                                Front Desk / Booking Staff
                            </h2>
                            <p className="text-slate-700">
                                Handles inquiries, bookings, and customer coordination.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-8">
                        <h3 className="font-semibold mb-4">How EventFlow Helps</h3>
                        <ul className="space-y-3 text-slate-600">
                            <li>• Faster and error-free bookings</li>
                            <li>• Instant access to customer and event details</li>
                            <li>• Professional invoices and receipts</li>
                            <li>• Improved customer confidence</li>
                        </ul>
                    </div>
                </div>

                {/* ACCOUNTS */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
                    <div className="lg:col-span-1">
                        <div className="bg-slate-100 rounded-xl p-6">
                            <h2 className="text-xl font-semibold mb-2">
                                Accounts & Finance Team
                            </h2>
                            <p className="text-slate-700">
                                Manages payments, expenses, and financial reporting.
                            </p>
                        </div>
                    </div>

                    <div className="lg:col-span-2 bg-white border border-slate-200 rounded-xl p-8">
                        <h3 className="font-semibold mb-4">How EventFlow Helps</h3>
                        <ul className="space-y-3 text-slate-600">
                            <li>• Accurate tracking of advances and dues</li>
                            <li>• Clear expense and supplier records</li>
                            <li>• Reliable monthly and yearly reports</li>
                            <li>• Reduced reconciliation effort</li>
                        </ul>
                    </div>
                </div>

            </section>

            {/* SUMMARY */}
            <section className="bg-slate-100 rounded-xl p-10">
                <h2 className="text-xl font-semibold mb-4">
                    One System. Multiple Roles.
                </h2>

                <p className="text-slate-700 max-w-3xl">
                    EventFlow adapts to the needs of every role within your organization.
                    Each user sees only what matters to them — ensuring clarity,
                    accountability, and efficiency across your entire operation.
                </p>
            </section>

            {/* NEXT */}
            <section className="border-t pt-8">
                <p className="text-slate-600">
                    Next, get started quickly with{" "}
                    <Link to="/docs/quick-start" className="text-[#C9A24E] font-medium">
                        Quick Start
                    </Link>{" "}
                    and begin using EventFlow in minutes.
                </p>
            </section>
  <DocNavigation
                    previous={{
                      title: "Tech Stack",
                      link: "/docs/tech-stack"
                    }}
                    next={{
                      title: "Quick Start",
                      link: "/docs/quick-start"
                    }}
                  />
        </div>
    );
}
